import React from 'react';

export default function EffectiveDate(props) {
  return (
    <div className={props.className} title={!props.isEffective ? 'Applied ‘Modified Following’ rule from ' + props.value : props.value}>
      <div className='comboText'>
        {!props.isEffective ? props.effDate : props.value}
      </div>
      {!props.isEffective ?  <span><sup className="redText">1</sup></span> : null}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/EffectiveDate.js